import React, {FC} from 'react';
import LaptopSizeWrapper, {Circle} from 'components/ContentPagesComponents/LaptopSizeWrapper';
import Hideable from 'components/utils/Hideable';

import * as styles from './styles.module.scss';

export interface IInfoPanelTextProps {
    title?: string;
    subTitle?: string;
	children: React.ReactNode;
	circle?: Circle;
}

const InfoPanelText: FC<IInfoPanelTextProps> = ({
	title,
	subTitle,
	children,
	circle = Circle.secondary,
}) => {
	return (
		<div className={styles.infoPanelOuter}>
			<LaptopSizeWrapper circle={circle}>
				<div className={styles.infoPanel}>
					<Hideable show={!!title}>
						<h2>{title}</h2>
					</Hideable>
					<div className={styles.items}>
						{children}
					</div>
					<Hideable show={!!subTitle}>
						<h6>{subTitle}</h6>
					</Hideable>
				</div>
			</LaptopSizeWrapper>

		</div>
	);
};
export default InfoPanelText;
